export default function initStandard() {
  $('.standard__button').on('click', function() {
    let id = $(this).attr('data-target')
    $(`.standard__content--${id}`).slideToggle()
  })
}



// WEBPACK FOOTER //
// ./scripts/components/standard.js